<template>
  <div class="freetime">
    <div class="schedule-container">
      <!-- 顶部日期及操作 -->
      <div class="schedule-header">
        <div class="schedule-header1">
          <span class="current-date">{{ currentMonth }} {{ currentYear }}</span>
          <div class="schedule-headerbtn">
            <span @click="prevWeek">< </span>
            <span @click="toThisweekvalue" class="thisweekspan">This Week</span>
            <span @click="nextWeek"> ></span>
          </div>
        </div>
        <!-- 提示语 -->
        <div style="height:45px">
          <el-alert
            :closable="false"
            type="warning"
            description="Activate high-demand teaching hours by referencing the highlighted table zones"
            show-icon>
            <template #title>
              Unlock Peak Prime Time Slots (
                <span class="ppt-text">PPT</span>
              )
            </template>
          </el-alert>
        </div>
        <button class="copy-btn" @click="copyLastWeekSlots">
          <img src="../../assets/copy.svg" class="copy_svg" /> Copy Last Week's
          Slots
        </button>
      </div>
      <!-- 星期表头 -->
      <div class="schedule-weekdays">
        <div class="weekday" v-for="(day, index) in weekdays" :key="index">
          <span class="weekday-date" v-if="day.day_num">{{ day.day_num }}</span>
          <span class="weekday-name" v-if="day.day_week">{{
            day.day_week
          }}
            <span v-if="!index" style="font-size: 10px; color: #6B7280;">({{zone_default}})</span>
          </span>
        </div>
      </div>
      <!-- 时间及内容表格 -->
      <div class="schedule-table">
        <div class="row-container">
          <!-- 循环时间段 -->
          <div
            class="time-row"
            v-for="(time, timeIndex) in timesList"
            :key="timeIndex"
          >
            <!-- 左侧时间列-->
            <div class="time-column"
              :class="{ 'hot-time': daysData[timeIndex * 2].is_hot }">
              <div v-if="daysData[timeIndex * 2].is_ppt" class="ppt-marker">
                <span>PPT</span>
              </div>
              <div class="time-slot">{{ time }}
                <p v-if="!zone_is_utc8" style="color: #FF2828;font-size: 11px"> <span> (UTC+8 </span> <span>{{utc8_timeList[timeIndex]}})</span></p>
              </div>
            </div>
            <div class="cells-row">
              <div class="cells-row1">
                <div
                  v-for="(item, index) in daysData[timeIndex * 2].date"
                  :key="index"
                  class="cell"
                  :data-row="timeIndex * 2"
                  :data-col="index"
                  v-bind:class="cellClass(item, timeIndex * 2, index)"
                  @mousedown.stop="handleMouseDown(item, timeIndex * 2, index)"
                  @mouseenter.stop="handleMouseEnter(timeIndex * 2, index)"
                  @click.stop="handleTableClick(item, timeIndex * 2, index)"
                >
                  <!-- 根据状态显示内容 -->
                  <div class="statusbox">
                    <div v-if="item.status == '2'" class="booked">
                      <span>BOOKED</span>
                    </div>
                    <div v-else-if="item.status == '1'" class="available">
                      <span>AVAILABLE</span>
                      <span
                        v-if="!item.is_expire"
                        class="availablecloseIcon"
                        @click.stop="delselectItem(item)"
                      >
                        <el-icon class="el-icon-close"></el-icon>
                      </span>
                    </div>
                    <div v-else-if="item.is_expire" class="disablecell"></div>
                    <div v-else class="empty"></div>
                  </div>
                </div>
              </div>
              <div class="cells-row1">
                <div
                  v-for="(item, index) in daysData[timeIndex * 2 + 1].date"
                  :key="index"
                  class="cell"
                  :data-row="timeIndex * 2 + 1"
                  :data-col="index"
                  v-bind:class="cellClass(item, timeIndex * 2 + 1, index)"
                  @mousedown.stop="
                    handleMouseDown(item, timeIndex * 2 + 1, index)
                  "
                  @mouseenter.stop="handleMouseEnter(timeIndex * 2 + 1, index)"
                  @click.stop="handleTableClick(item, timeIndex * 2 + 1, index)"
                >
                  <!-- 根据状态显示内容 -->
                  <div class="statusbox">
                    <div v-if="item.status == '2'" class="booked">
                      <span>BOOKED</span>
                    </div>
                    <div v-else-if="item.status == '1'" class="available">
                      <span>AVAILABLE</span>
                      <span
                        v-if="!item.is_expire"
                        class="availablecloseIcon"
                        @click.stop="delselectItem(item)"
                      >
                        <el-icon class="el-icon-close"></el-icon>
                      </span>
                    </div>
                    <div v-else-if="item.is_expire" class="disablecell"></div>
                    <div v-else class="empty"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 弹窗显示详细信息 -->
      <el-dialog
        :visible.sync="showDetailFlag"
        width="26%"
        custom-class="tipslDialog"
        @close="closetipdialogEvent"
      >
        <div>
          <div>
            <p>{{ tipsDetailtex.time }}</p>
            <p>{{ tipsDetailtex.duration }} minutes</p>
          </div>
          <hr />
          <div>
            <p>{{ tipsDetailtex.sub_title }}</p>
            <p>{{ tipsDetailtex.level_title }}</p>
          </div>
          <el-button
            v-if="showActiveexpire2"
            class="Confirmbtn1"
            @click="tohandletipdialog"
            >Cancel This Class</el-button
          >
          <div v-if="showActiveexpire1">
            <el-button :disabled="true" class="Confirmbtn2"
              >Cancel This Class</el-button
            >
            <p class="Confirmbtn2pspan">{{ tipsDetailtex.tip_info }}</p>
          </div>
        </div>
      </el-dialog>
      <!-- Copy弹框 -->
      <el-dialog
        :visible.sync="showCopydetailFlag"
        width="80%"
        custom-class="copydetailDialog"
      >
        <!-- 顶部日期及操作 -->
        <div class="copyschedule-header">
          <div class="copyschedule-header1">
            <!-- copy提示文字 -->
            <div>
              <p>
                Copy <span class="tipnumtips">{{ copyweekValue }}</span> slots
                from last week to the following week(s):
              </p>
              <p>Can only copy slots for times students can hook</p>
            </div>
            <!-- 计数器 -->
            <el-input-number
              v-model="copyweekValue"
              :step="1"
              :min="1"
              @change="changeCopyweekValue"
            ></el-input-number>
          </div>
          <!-- 日期  -->
          <div>
            <p>{{ dayshowTitle }}</p>
          </div>
          <!-- 按钮部分 -->
          <div>
            <button class="copycancel-btn" @click="cancelcopydetail">
              Cancel
            </button>
            <button class="copysubmit-btn" @click="submitcopydetail">
              Submit
            </button>
          </div>
        </div>
        <!-- 星期表头 -->
        <div class="copyschedule-weekdays">
          <div
            class="copyweekday"
            v-for="(day, index) in copyweekdays"
            :key="index"
          >
            <span class="copyweekday-date" v-if="day.day_num">{{
              day.day_num
            }}</span>
            <span class="copyweekday-name" v-if="day.day_week">{{
              day.day_week
            }}</span>
          </div>
        </div>
        <!-- 时间及内容表格 -->
        <div class="copyschedule-table">
          <div class="copyrow-container">
            <!-- 循环时间段 -->
            <div
              class="copytime-row"
              v-for="(time, timeIndex) in copytimesList"
              :key="timeIndex"
            >
              <!-- 左侧时间列-->
              <div class="copytime-column">
                <div class="copytime-slot">{{ time }}</div>
              </div>
              <div class="copycells-row">
                <div class="copycells-row1">
                  <div
                    v-for="(item, index) in copydaysData[timeIndex * 2].date"
                    :key="index"
                    class="copycell"
                    :data-row="timeIndex * 2"
                    :data-col="index"
                  >
                    <!-- 根据状态显示内容 -->
                    <div class="copystatusbox">
                      <!-- 深灰色 -->
                      <div
                        v-if="item.status == '1'"
                        class="copyavailable"
                      ></div>
                      <!-- 过期状态 -->
                      <div
                        v-else-if="item.is_expire"
                        class="copydisablecell"
                      ></div>
                      <div v-else-if="item.status == '2'" class="copybooked">
                        <span class="availspan">AVAIL</span>
                        <div class="copybookedcheck">
                          <span>Copy</span>
                          <el-checkbox
                            v-model="item.checked"
                            @change="collectSelectedItems"
                          ></el-checkbox>
                        </div>
                      </div>
                      <div v-else class="copyempty"></div>
                    </div>
                  </div>
                </div>
                <div class="copycells-row1">
                  <div
                    v-for="(item, index) in copydaysData[timeIndex * 2 + 1]
                      .date"
                    :key="index"
                    class="copycell"
                    :data-row="timeIndex * 2 + 1"
                    :data-col="index"
                  >
                    <!-- 根据状态显示内容 -->
                    <div class="copystatusbox">
                      <!-- 深灰色 -->
                      <div
                        v-if="item.status == '1'"
                        class="copyavailable"
                      ></div>
                      <!-- 过期状态 -->
                      <div
                        v-else-if="item.is_expire"
                        class="copydisablecell"
                      ></div>
                      <div v-else-if="item.status == '2'" class="copybooked">
                        <span class="availspan">AVAIL</span>
                        <div class="copybookedcheck">
                          <span>Copy</span>
                          <el-checkbox
                            v-model="item.checked"
                            @change="collectSelectedItems"
                          ></el-checkbox>
                        </div>
                      </div>
                      <div v-else class="copyempty"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
      <!-- copysubmit弹框 -->
      <el-dialog
        title="Confirm the copy of last week's slots"
        :visible.sync="submitdialogVisible"
        width="30%"
        custom-class="copysubmitDialog"
      >
        <div>
          <p>
            You have copied
            <span class="tipnumtips" v-if="selectedItems">
              {{ selectedItems.length * copyweekValue }}
            </span>
            slots to the week of
          </p>
          <span>{{ dayshowTitle }}</span>
          <p>
            <img src="../../assets/editIcon.svg" alt="" class="tipsIcon" />Tips
          </p>

          <p>
            Copying can take some time. Please do not close this page
            whilecopying as this can interrupt the process.
          </p>
          <span slot="footer" class="dialog-footer">
            <el-button class="cancelbtn1" @click="submitdialogVisible = false"
              >Cancel</el-button
            >
            <el-button class="Confirmbtn1" @click="tohandleSubmitdialog"
              >Confirm</el-button
            >
          </span>
        </div>
      </el-dialog>
      <el-dialog
        title="Copied!"
        :visible.sync="CopieddialogVisible"
        width="30%"
        custom-class="copysubmitDialog"
      >
        <div>
          <p>
            <span style="color: #ff904d">{{ success_num }} </span> Times Slots
            were copied successfully
          </p>
          <p>
            <span style="color: #ff904d">0 </span> Times Slots failed to copy
          </p>
          <div style="margin: 20px 0">
            Class demand may affect the success rate of the copyingPlease check
            the Bookings tab to confirm the finalcopy.
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button class="Confirmbtn1" @click="CopieddialogVisible = false"
              >OK</el-button
            >
          </span>
        </div>
      </el-dialog>
      <!-- 选择弹框 -->
      <el-dialog
        title="Confirm selected this time"
        :visible.sync="selectdialogVisible"
        width="28%"
        custom-class="selectDialog"
        @close="selecthandleClose"
      >
        <span>Are you sure to select?</span>
        <span slot="footer" class="dialog-footer">
          <el-button class="cancelbtn1" @click="selecthandleClose"
            >Cancel</el-button
          >
          <el-button class="Confirmbtn1" @click="tohandleSelectdialog"
            >Confirm</el-button
          >
        </span>
      </el-dialog>
      <!-- 取消课程弹框 -->
      <el-dialog
        title="Confirm cancel this class"
        :visible.sync="canceldialogVisible"
        width="35%"
        :before-close="cancelhandleClose"
        custom-class="cancelDialog"
      >
        <span v-if="showTimetip2">Are you sure to cancel?</span>
        <span v-if="showTimetip1"
          >Cancelling this lesson (<24 hours notice) will affect your payment
          for this session</span
        >
        <p style="margin-top: 10px" v-if="showTimetip1">
          Proceed with cancellation ?
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button
            class="cancelbtn1"
            v-if="showTimetip2"
            @click="tohandleCanceldialog"
            >Confirm</el-button
          >
          <el-button
            class="Confirmbtn1"
            v-if="showTimetip2"
            @click="canceldialogVisible = false"
            >Cancel</el-button
          >
          <el-button
            class="cancelbtn1"
            v-if="showTimetip1"
            @click="tohandleCanceldialog"
            >Yes,Cancel Lesson</el-button
          >
          <el-button
            class="Confirmbtn1"
            v-if="showTimetip1"
            @click="canceldialogVisible = false"
            >No,Keep Lesson</el-button
          >
        </span>
      </el-dialog>
      <!-- 不能复制弹框 -->
      <el-dialog
        :visible.sync="NocopydialogVisible"
        width="30%"
        custom-class="nocopyDialog"
      >
        <p>No course slots are available to copy from last week.</p>
        <span slot="footer" class="dialog-footer">
          <el-button class="Confirmbtn1" @click="NocopydialogVisible = false"
            >OK</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "FreeTime",
  data() {
    return {
      selectedItems: [],
      success_num: "",
      CopieddialogVisible: false,
      canceldialogVisible: false, //取消课程弹框
      showTimetip1: false,
      showTimetip2: false,
      // copy多选框
      copyChecked: false,
      selectdialogVisible: false,
      // 计数器默认值
      weekValue: 0,
      copyweekValue: 1,
      // 当前年月
      currentYear: "",
      currentMonth: "",
      // 星期数据
      weekdays: [],
      // copy星期数据
      copyweekdays: [],
      // 时间数据
      timesList: [],
      // copy时间数据
      copytimesList: [],
      copytimeList: [],
      copyselectedItems: [],
      // 每一天的时段数据
      daysData: [],
      // copy每一天的数据
      copydaysData: [],
      daysDataMap: {},
      copydaysDataMap: {},
      showDetailFlag: false, // 是否显示详情弹窗
      currentDetail: {}, // 当前详情数据
      showCopydetailFlag: false,
      submitdialogVisible: false,
      // 表格选择状态管理
      selectionState: {
        isSelecting: false, // 是否正在进行选择操作
        startCell: null, // 选择起始单元格 {row, col}
        endCell: null, // 选择结束单元格
        activeCell: null, // 当前活动单元格
        multipleCells: new Set(), // 存储所有选中单元格的键值 "row,col"
        ctrlKey: false, // Ctrl/Cmd键状态
        shiftKey: false, // Shift键状态
      },
      activeStatus: "", //存储当前状态
      activeExpire: "", //存储当前过期状态
      // 显示弹框判断
      showActiveexpire1: false,
      showActiveexpire2: false,
      // 存储当前单元格信息
      tipsDetailtex: {},
      // copy页面展示日期
      dayshowTitle: "",
      // 删除当前约课
      cancellesson: "",
      startTime: "",
      NocopydialogVisible: false,
      zone_is_utc8:'',
      zone_default:'',
      utc8_timeList:[]
    };
  },
  created() {
    this.getOpenSlot();
  },
  mounted() {
    // 注册全局键盘和鼠标事件监听
    window.addEventListener("mouseup", this.handleMouseUp);
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听，防止内存泄漏
    window.removeEventListener("mouseup", this.handleMouseUp);
  },
  methods: {
    toThisweekvalue() {
      this.weekValue = 0;
      this.getOpenSlot();
    },
    cancelhandleClose() {
      this.canceldialogVisible = false;
    },
    // 关闭弹框事件
    closetipdialogEvent() {
      this.activeStatus = undefined;
    },
    // 收集所有选中的item
    collectSelectedItems() {
      this.selectedItems = [];
      this.copydaysData.forEach((rowGroup) => {
        rowGroup.date.forEach((item) => {
          if (item.status == "2" && item.checked&&!item.is_expire) {
            this.selectedItems.push(item);
          }
        });
      });
    },
    // 改变copy计数器事件
    changeCopyweekValue(newValue) {
      if (newValue < 1) {
        this.copyweekValue = 1;
      } else {
        this.getCopyfreearea();
      }
    },
    // 获取复制空闲时间区间
    getCopyfreearea() {
      this.$http
        .get(
          `/tutor/api/getCopyDate?week=${this.weekValue}&copy_week=${this.copyweekValue}`
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.dayshowTitle = res.data.data.day_show;
          }
        });
    },
    // 批量添加事件
    tohandleSelectdialog() {
      const dayIds = [];
      this.selectionState.multipleCells.forEach((key) => {
        const item = this.getItemData(key);
        dayIds.push(item.day_id);
      });
      if (dayIds.length == 1) {
        this.$http
          .post("/tutor/api/saveOpenSlot", {
            day_id: dayIds[0],
          })
          .then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: "Added successfully",
              });
              this.selectdialogVisible = false;
              this.getOpenSlot();
            }
          });
      } else {
        function convertDayIdsToFormData(dayIds) {
          const formData = new FormData();
          // 先检查是否为有效的数组，避免报错
          if (Array.isArray(dayIds) && dayIds.length > 0) {
            dayIds.forEach((id, index) => {
              // 按照索引格式添加，如day_ids[0]、day_ids[1]等
              formData.append(`day_ids[${index}]`, id);
            });
          }
          return formData;
        }
        this.$http
          .post(
            "/tutor/api/saveOpenSlotBatch",
            convertDayIdsToFormData(dayIds),
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: "Added successfully",
              });
              this.selectdialogVisible = false;
              this.getOpenSlot();
            }
          });
      }
    },

    // 关闭弹框
    selecthandleClose() {
      this.selectdialogVisible = false;
      this.selectionState.multipleCells = new Set();
      this.selectionState.startCell = null;
      this.selectionState.endCell = null;
      this.selectionState.activeCell = null;
    },
    // 取消选中当前单元格
    delselectItem(cell) {
      this.$http
        .post("/tutor/api/cancelOpenSlot", {
          day_id: cell.day_id,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "Cancel successfully",
            });
            this.getOpenSlot();
          }
        });
    },
    // 获取日历数据
    getOpenSlot() {
      this.$http
        .get("/tutor/api/getOpenSlot?week=" + this.weekValue)
        .then((res) => {
          if (res.data.code == 200) {
            // 获取表头数据
            this.weekdays = res.data.data.week_list;
            this.weekdays.unshift({
              day_num: undefined,
              day_week: "Time",
            });
            // 获取时间列
            this.timesList = res.data.data.time_list
              .filter((_, index) => index % 2 === 1)
              .map((item) => item.time);
            // 获取中国时区时间列
            this.utc8_timeList = res.data.data.time_list
              .filter((_, index) => index % 2 === 1)
              .map((item) => item.utc8_time);

            this.daysData = res.data.data.time_list;
            this.handleDateData();
            // 获取月份和年份
            this.currentMonth = res.data.data.month;
            this.currentYear = res.data.data.year;
            //获取时区
            this.zone_is_utc8 = res.data.data.zone_is_utc8
            this.zone_default = res.data.data.zone_default
          }
        });
    },
    // 获取copy日历数据
    getcopyOpenSlot() {
      this.$http
        .get("/tutor/api/getCopyOpenSlot?week=" + this.weekValue)
        .then((res) => {
          if (res.data.code == 200) {
            // 获取表头数据
            this.copyweekdays = res.data.data.week_list;
            this.copyweekdays.unshift({
              day_num: undefined,
              day_week: "Time",
            });
            // 获取时间列
            this.copytimesList = res.data.data.time_list
              .filter((_, index) => index % 2 === 1)
              .map((item) => item.time);
            this.copydaysData = res.data.data.time_list;
            this.copydaysData.forEach((rowGroup, rowIndex) => {
              rowGroup.date.forEach((item, itemIndex) => {
                if (item.status == "2") {
                  // 使用$set确保添加的属性具有响应性
                  this.$set(
                    this.copydaysData[rowIndex].date[itemIndex],
                    "checked",
                    true
                  );
                }
              });
            });
            this.handlecopyDateData();
          }
        });
    },
    // 处理date数据：生成唯一key并构建dateMap
    handleDateData() {
      // 清空原有map
      this.daysDataMap = {};
      this.daysData.forEach((timeItem, timeIndex) => {
        // 确保当前timeItem有date数组
        if (!timeItem.date || !Array.isArray(timeItem.date)) return;
        // 遍历当前timeItem的date数组
        timeItem.date.forEach((dateItem, dateIndex) => {
          // 生成唯一key：time_list索引 + date索引（格式："timeIndex-dateIndex"）
          const uniqueKey = `${timeIndex},${dateIndex}`;
          // 给date项添加唯一key属性（便于后续使用）
          dateItem.uniqueKey = uniqueKey;
          // 将date项存入map，key为生成的uniqueKey
          this.daysDataMap[uniqueKey] = dateItem;
        });
      });
    },
    // 处理copdate数据：生成唯一key并构建dateMap
    handlecopyDateData() {
      // 清空原有map
      this.copydaysDataMap = {};
      // 遍历time_list（copydaysData数组）
      this.copydaysData.forEach((timeItem, timeIndex) => {
        // 确保当前timeItem有date数组
        if (!timeItem.date || !Array.isArray(timeItem.date)) return;
        // 遍历当前timeItem的date数组
        timeItem.date.forEach((dateItem, dateIndex) => {
          // 生成唯一key：time_list索引 + date索引（格式："timeIndex-dateIndex"）
          const uniqueKey = `${timeIndex},${dateIndex}`;
          // 给date项添加唯一key属性（便于后续使用）
          dateItem.uniqueKey = uniqueKey;
          // 将date项存入map，key为生成的uniqueKey
          this.copydaysDataMap[uniqueKey] = dateItem;
        });
      });
    },
    tohandleSubmitdialog() {
      this.submitdialogVisible = false;
      let selectdayIds = [];
      this.collectSelectedItems();
      if (this.selectedItems && this.selectedItems.length > 0) {
        selectdayIds = this.selectedItems.map((item) => item.day_id);
      }
      if (selectdayIds.length == 0) {
        this.$message({
          type: "error",
          message: "Please select the content to be copied",
        });
        return;
      }
      function convertDayIdsToFormData(selectdayIds, weekValue, copyweekValue) {
        const formData = new FormData();
        formData.append("week", weekValue);
        formData.append("copy_week", copyweekValue);
        if (Array.isArray(selectdayIds) && selectdayIds.length > 0) {
          selectdayIds.forEach((id, index) => {
            formData.append(`day_ids[${index}]`, id);
          });
        }
        return formData;
      }
      this.$http
        .post(
          "/tutor/api/copyOpenSlot",
          convertDayIdsToFormData(
            selectdayIds,
            this.weekValue,
            this.copyweekValue
          ),
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.success_num = res.data.data.success_num;
            this.CopieddialogVisible = true;
            this.getCopyfreearea();
            this.getcopyOpenSlot();
            this.getOpenSlot();
            this.showCopydetailFlag = false;
          }
        });
    },
    submitcopydetail() {
      this.submitdialogVisible = true;
      this.collectSelectedItems();
    },
    cancelcopydetail() {
      this.showCopydetailFlag = false;
      this.copyweekValue = 1;
    },
    tohandleCanceldialog() {
      this.$http
        .post("/tutor/api/cancelClass", {
          lesson_sn: this.cancellesson,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "Cancel successfully",
            });
            this.canceldialogVisible = false;
            this.showDetailFlag = false;
            this.getOpenSlot();
          }
        });
    },
    tohandletipdialog() {
      this.canceldialogVisible = true;
      const startTime = new Date(this.startTime).getTime();
      const currentTime = new Date().getTime();
      const timeDiff = startTime - currentTime;
      if (timeDiff > 0 && timeDiff < 86400000) {
        // 小于24小时
        this.showTimetip1 = true;
        this.showTimetip2 = false;
      } else {
        // 大于等于24小时
        this.showTimetip1 = false;
        this.showTimetip2 = true;
      }
    },
    // 上一周
    prevWeek() {
      this.weekValue -= 1;
      this.getOpenSlot();
    },
    // 下一周
    nextWeek() {
      this.weekValue += 1;
      this.getOpenSlot();
    },
    // 复制按钮
    copyLastWeekSlots() {
      if (this.weekValue >= 0) {
        this.showCopydetailFlag = true;
        this.getCopyfreearea();
        this.getcopyOpenSlot();
      } else {
        this.NocopydialogVisible = true;
      }
    },
    handleMouseUp() {
      if (this.activeStatus == 0) {
        if (this.selectionState.isSelecting == true) {
          // 鼠标释放时结束选择状态
          this.selectionState.isSelecting = false;
          this.selectdialogVisible = true;
        }
      } else if (this.activeStatus == 1) {
        // 鼠标释放时结束选择状态
        this.selectionState.isSelecting = false;
        this.clearSelection();
      } else if (this.activeStatus == 2) {
        // 鼠标释放时结束选择状态
        this.selectionState.isSelecting = false;
        this.showDetailFlag = true;
        if (this.activeExpire) {
          this.showActiveexpire1 = true;
          this.showActiveexpire2 = false;
        } else {
          this.showActiveexpire1 = false;
          this.showActiveexpire2 = true;
        }
      }
    },
    // 鼠标事件处理
    handleMouseDown(item, row, col) {
      this.activeStatus = item.status;
      this.activeExpire = item.is_expire;
      this.tipsDetailtex = item.class_info;
      this.cancellesson = item.class_info.lesson_sn;
      this.startTime = item.class_info.start_at;
      if (!item.is_expire) {
        // 开始选择操作
        this.selectionState.isSelecting = true;

        if (this.selectionState.ctrlKey) {
          // Ctrl/Cmd键按下时，切换单元格选中状态（添加/移除）
          this.toggleCellSelection(row, col);
        } else if (
          this.selectionState.shiftKey &&
          this.selectionState.activeCell
        ) {
          // Shift键按下时，从活动单元格扩展选择区域
          this.selectionState.startCell = { ...this.selectionState.activeCell };
          this.selectionState.endCell = { row, col };
          this.updateSelection();
        } else {
          // 普通点击，清除之前选择并设置新的选择
          if (!this.selectionState.ctrlKey) {
            this.clearSelection();
          }
          this.selectionState.startCell = { row, col };
          this.selectionState.endCell = { row, col };
          this.selectionState.activeCell = { row, col };
          this.updateSelection();
        }
      }
    },
    handleMouseEnter(row, col) {
      // 鼠标移动时更新选择区域（仅在拖动选择时生效）
      if (this.selectionState.isSelecting && !this.selectionState.ctrlKey) {
        this.selectionState.endCell = { row, col };
        this.updateSelection();
      }
    },
    handleTableClick(item, row, col) {
      this.activeStatus = item.status;
      this.cancellesson = item.class_info.lesson_sn;
      this.startTime = item.class_info.start_at;
      if (!item.is_expire) {
        // 处理单击事件（非拖动操作）
        if (!this.selectionState.isSelecting) {
          if (!this.selectionState.ctrlKey) {
            this.clearSelection();
          }
          if (this.selectionState.ctrlKey) {
            // Ctrl/Cmd下的单击：切换选中状态
            this.toggleCellSelection(row, col);
          } else {
            // 普通单击：直接选中
            this.selectSingleCell(row, col);
          }
          this.selectionState.activeCell = { row, col };
        }
      }
    },
    // 选择逻辑
    cellClass(item, row, col) {
      // 返回单元格的样式类（选中/活动状态）
      if (item.status == 0) {
        return {
          selected: this.isCellSelected(row, col),
          active: this.isCellActive(row, col),
        };
      }
    },
    isCellSelected(row, col) {
      // 判断单元格是否被选中
      const key = `${row},${col}`;
      return (
        this.selectionState.multipleCells.has(key) || this.isInRange(row, col)
      );
    },
    isCellActive(row, col) {
      // 判断单元格是否为活动单元格（当前操作焦点）
      return (
        this.selectionState.activeCell &&
        this.selectionState.activeCell.row === row &&
        this.selectionState.activeCell.col === col
      );
    },
    isInRange(row, col) {
      // 判断单元格是否在选择范围内（用于拖动选择）
      if (!this.selectionState.startCell || !this.selectionState.endCell)
        return false;
      const minRow = Math.min(
        this.selectionState.startCell.row,
        this.selectionState.endCell.row
      );
      const maxRow = Math.max(
        this.selectionState.startCell.row,
        this.selectionState.endCell.row
      );
      const minCol = Math.min(
        this.selectionState.startCell.col,
        this.selectionState.endCell.col
      );
      const maxCol = Math.max(
        this.selectionState.startCell.col,
        this.selectionState.endCell.col
      );
      return row >= minRow && row <= maxRow && col >= minCol && col <= maxCol;
    },
    selectSingleCell(row, col) {
      // 选中单个单元格
      const key = `${row},${col}`;
      const item = this.getItemData(key);
      if (item.status == 0) {
        this.selectionState.multipleCells.add(key);
      }
    },
    getItemData(key) {
      return this.daysDataMap[key];
    },
    toggleCellSelection(row, col) {
      // 切换单元格选中状态（选中/取消选中）
      const key = `${row},${col}`;
      const item = this.getItemData(key);
      if (item.status == 0) {
        if (this.selectionState.multipleCells.has(key)) {
          this.selectionState.multipleCells.delete(key);
        } else {
          this.selectionState.multipleCells.add(key);
        }
      }
    },
    updateSelection() {
      // 更新选择区域（基于起始和结束单元格）
      this.selectionState.multipleCells = new Set();
      if (this.selectionState.startCell && this.selectionState.endCell) {
        // 计算选择区域的行列范围
        const minRow = Math.min(
          this.selectionState.startCell.row,
          this.selectionState.endCell.row
        );
        const maxRow = Math.max(
          this.selectionState.startCell.row,
          this.selectionState.endCell.row
        );
        const minCol = Math.min(
          this.selectionState.startCell.col,
          this.selectionState.endCell.col
        );
        const maxCol = Math.max(
          this.selectionState.startCell.col,
          this.selectionState.endCell.col
        );
        // 将范围内的所有单元格添加到选中集合
        for (let r = minRow; r <= maxRow; r++) {
          for (let c = minCol; c <= maxCol; c++) {
            const key = `${r},${c}`;
            const item = this.getItemData(key);
            if (item.status == 0) {
              this.selectionState.multipleCells.add(key);
            }
          }
        }
      }
    },

    clearSelection() {
      // 清除所有选择状态
      this.selectionState.multipleCells = new Set();
      this.selectionState.startCell = null;
      this.selectionState.endCell = null;
      this.selectionState.activeCell = null;
    },
  },
};
</script>

<style scoped lang="less">
.freetime{
  margin-top: 20px;
  padding: 30px 0;
  background-color: #fff;
}
.schedule-container {
  width: 90%;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  .schedule-header {
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .schedule-header1 {
      width: 20%;
      height: 45px;
      background: #ff904d;
      display: flex;
      align-items: center;
      border-radius: 4px;
      justify-content: space-around;
      color: #fff;
      padding: 0 5px;
      .schedule-headerbtn {
        margin-left:5px;
        font-size: 14px;
        span {
          cursor: pointer;
        }
      }
      .current-date {
        font-size: 14px;
        font-weight: bold;
      }
    }
    .copy-btn {
      height: 45px;
      background-color: #ff904d;
      color: white;
      border: none;
      padding: 8px 12px;
      cursor: pointer;
      border-radius: 4px;
      .copy_svg {
        width: 14px;
        height: 14px;
      }
    }
    /deep/ .el-alert{
      padding: 0 5px !important;
      height: 45px;
      color: #FF6304 !important;
      background-color: #F9D75B !important;
      .el-alert__content .el-alert__description{
        color: #FF6304 !important;
      }
    }
  }
  .schedule-weekdays {
    display: flex;
    .weekday {
      flex: 1;
      text-align: center;
      padding: 5px 0;
      border: 1px solid #e5e7eb;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      .weekday-date {
        display: block;
        font-weight: bold;
      }
    }
  }
  .schedule-table {
    border: 1px solid #e5e7eb;
    border-top: none;

    .row-container {
      display: flex;
      flex-direction: column;
    }

    .time-row {
      display: flex;
      border-bottom: 1px solid #e5e7eb;

      &:last-child {
        border-bottom: none;
      }
    }

    .time-column {
      width: 156px;
      border-right: 1px solid #e5e7eb;
      position: relative;
      .time-slot {
        text-align: center;
        padding: 16.3px 0;
        height: 100%;
      }
    }

    .cells-row {
      display: flex;
      flex-direction: column;
      flex: 1;
      .cells-row1 {
        width: 100%;
        height: 50%;
        display: flex;
        .cell {
          flex: 1;
          /* 禁用文字选中，防止干扰选择操作 */
          -webkit-touch-callout: none;
          -webkit-user-select: none;
          -khtml-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          &:last-child {
            border-right: none;
          }

          .slot-content {
            position: relative;
            height: 100%;
            min-height: 55px;
          }
          .statusbox {
            width: 100%;
            height: 100%;
            .booked {
              width: 100%;
              height: 100%;
              background-color: #03ae00;
              color: white;
              cursor: pointer;
              font-size: 10px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              border: 1px dashed #e0e1e3da;
            }

            .available {
              width: 100%;
              height: 100%;
              background-color: #0072d2;
              color: white;
              cursor: pointer;
              font-size: 10px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              position: relative;
              border: 1px dashed #e0e1e3da;
              .availablecloseIcon {
                position: absolute;
                top: 2px;
                right: 4px;
              }
            }

            .empty {
              height: 100%;
              border: 1px dashed #e0e1e3da;
            }
          }

          .disablecell {
            width: 100%;
            height: 100%;
            background: #ecedee;
            cursor: not-allowed; /* 鼠标悬停显示禁止图标 */
            opacity: 0.7;
            border: 1px dashed #e0e1e3da;
          }
        }
        /* 选择状态样式 */
        .cell.selected {
          background-color: rgba(59, 130, 246, 0.2) !important;
        }
        // .cell.active {
        //   border: 2px solid #3b82f6 !important;
        // }
        .cell:hover {
          background-color: rgba(59, 130, 246, 0.1);
        }
      }
    }
  }
  .copyschedule-header {
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .copyschedule-header1 {
      width: 55%;
      justify-content: space-between;
      display: flex;
      .el-input-number {
        width: 130px !important;
        margin-left: 20px;
      }
    }
    .copysubmit-btn {
      width: 100px;
      background-color: #ff904d;
      color: white;
      border: none;
      padding: 8px 12px;
      cursor: pointer;
      margin-left: 10px;
      border-radius: 5px;
    }
    .copycancel-btn {
      width: 100px;
      background-color: #fff;
      color: #8f8d8d;
      border: 1px solid #ccccccfd;
      padding: 7px 12px;
      cursor: pointer;
      border-radius: 5px;
    }
  }
  .copyschedule-weekdays {
    display: flex;
    .copyweekday {
      flex: 1;
      text-align: center;
      padding: 5px 0;
      border: 1px solid #e5e7eb;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      .copyweekday-date {
        display: block;
        font-weight: bold;
      }
    }
  }
  .copyschedule-table {
    border: 1px solid #e5e7eb;
    border-top: none;

    .copyrow-container {
      display: flex;
      flex-direction: column;
    }

    .copytime-row {
      display: flex;
      border-bottom: 1px solid #e5e7eb;

      &:last-child {
        border-bottom: none;
      }
    }

    .copytime-column {
      width: 12.45%;
      border-right: 1px solid #e5e7eb;

      .copytime-slot {
        text-align: center;
        padding: 16.3px 0;
        height: 100%;
      }
    }

    .copycells-row {
      display: flex;
      flex-direction: column;
      flex: 1;
      .copycells-row1 {
        width: 100%;
        height: 50%;
        display: flex;
        .copycell {
          flex: 1;
          /* 禁用文字选中，防止干扰选择操作 */
          -webkit-touch-callout: none;
          -webkit-user-select: none;
          -khtml-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          &:last-child {
            border-right: none;
          }

          .copyslot-content {
            position: relative;
            height: 100%;
            min-height: 55px;
          }
          .copystatusbox {
            width: 100%;
            height: 100%;
            .copybooked {
              width: 100%;
              height: 100%;
              background-color: #20bfb4;
              color: white;
              cursor: pointer;
              font-size: 10px;
              display: flex;
              align-items: center;
              position: relative;
              border: 1px dashed #e5e7eb;
              .availspan {
                padding-left: 5px;
              }
              .copybookedcheck {
                width: 40%;
                position: absolute;
                top: 0;
                right: 5px;
                display: flex;
                justify-content: space-between;
                align-items: center;
              }
            }

            .copyavailable {
              width: 100%;
              height: 100%;
              background-color: #d1d5db;
              color: white;
              cursor: pointer;
              font-size: 10px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              position: relative;
              border: 1px dashed #e5e7eb;

              .copyavailablecloseIcon {
                position: absolute;
                top: 2px;
                right: 4px;
              }
            }

            .copyempty {
              height: 100%;
              border: 1px dashed #e5e7eb;
            }
          }

          .copydisablecell {
            width: 100%;
            height: 100%;
            background: #ecedee;
            cursor: not-allowed; /* 鼠标悬停显示禁止图标 */
            opacity: 0.7;
          }
        }
        /* 选择状态样式 */
        .copycell.selected {
          background-color: rgba(59, 130, 246, 0.2) !important;
        }
        // .cell.active {
        //   border: 2px solid #3b82f6 !important;
        // }
        .copycell:hover {
          background-color: rgba(59, 130, 246, 0.1);
        }
      }
    }
  }
}
/deep/ .tipslDialog {
  background: #fffae5;
  .el-dialog__header {
    padding: 45px 84px 0;
  }
  .el-dialog__body {
    padding: 0px 30px 0 !important;
    font-size: 20px;
    font-weight: 100;
    height: 90%;
    p {
      line-height: 40px;
    }
  }
  .Confirmbtn1 {
    width: 94%;
    height: 45px;
    margin-left: 2%;
    color: #fff;
    background: #ff904d;
    border: none;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .Confirmbtn2 {
    width: 98%;
    height: 45px;
    color: #ff904d;
    background: transparent;
    border: 1px solid #ff904d;
    margin-top: 10px;
  }
  .Confirmbtn2pspan {
    color: #ff904d;
    font-size: 16px;
    padding-bottom: 20px;
  }
}
/deep/ .copydetailDialog {
  margin-top: 5vh !important;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 22px 84px 35px !important;
  }
}
/deep/ .copysubmitDialog {
  background: #fffae5;
  .el-dialog__header {
    padding: 52px 30px 0;
    .el-dialog__title {
      font-size: 24px;
    }
  }
  .el-dialog__body {
    padding: 18px 30px 80px !important;
    font-size: 16px;
    .dialog-footer {
      float: right;
      margin-top: 10px;
      margin-bottom: 10px;

      .cancelbtn1 {
        width: 150px;
        background: transparent;
        font-size: 18px;
      }
      .Confirmbtn1 {
        width: 150px;
        background: #ff904d;
        color: #fff;
        font-size: 18px;
      }
    }
    .tipsIcon {
      width: 15px;
      height: 15px;
    }
    p {
      margin-top: 10px;
    }
  }
}
/deep/ .nocopyDialog {
  background: #fffae5;
  height: 20%;
  .dialog-footer {
    float: right;
    margin-right: 20px;
  }
}
/deep/ .selectDialog {
  background: #fffae5;
  .el-dialog__title {
    font-size: 22px;
  }
  .cancelbtn1{
    background: transparent;
    color: #666;
    border: 1px solid #ccc;
  }
}
.tipnumtips {
  color: #ff904d;
}
/* 禁用所有表格元素的文字选中 */
.schedule-weekdays,
.weekday,
.time-column,
.time-slot,
.statusbox,
.empty,
.available {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
/deep/ .copybookedcheck .is-checked .el-checkbox__inner {
  background-color: #fff;
  border-color: #20bfb4;
}
/deep/
  .copybookedcheck
  .el-checkbox__input.is-checked
  .el-checkbox__inner::after {
  border-color: #20bfb4;
}
/deep/ .cancelDialog {
  background: #fffae5;
  margin-top: 36vh !important;
  .el-dialog__header {
    padding: 40px 30px 0;
    .el-dialog__title {
      font-size: 20px;
      font-weight: 100;
    }
  }
  .el-dialog__body {
    padding: 22px 30px 0 !important;
    color: #ff904d;
    font-size: 20px;
    font-weight: 100;
  }
  .cancelbtn1 {
    width: 200px;
    color: #000;
    background-color: transparent;
    border: 1px solid #ccc;
  }
  .Confirmbtn1 {
    width: 200px;
    color: #fff;
  }
}
/* 时间列粉色背景样式 */
.time-column.hot-time {
  background-color: #FFD2C8;
}
/* PPT标识样式 - 左上角显示 */
.ppt-marker {
  position: absolute;
  top: 0px;
  left: -22px;
  color: #10B981;
  font-size: 12px;
}
/* 时间文本样式微调，避免被PPT标识遮挡 */
.time-slot {
  padding-left: 18px; /* 给左侧PPT图标留出空间 */
}
.ppt-text {
  color: #03AE00;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/views/FreeTime.vue